export default __webpack_public_path__ + "static/media/review-user-avatar.2d6fa038.jpg";